export default {
  NEWS: [
    {
      key: "index",
      name: "번호",
      isSorted: false,
    },
    {
      key: "category",
      name: "구분",
      isSorted: false,
    },
    {
      key: "title",
      name: "제목",
      isSorted: false,
    },
    {
      key: "date",
      name: "등록일",
      isSorted: false,
    },
  ],
};
